module.exports = __webpack_public_path__ + "static/media/RecipientsIcon.ecb57d1b.svg";